<div id="loader">
    <div id="shadow"></div>
    <div id="box"><img class="box" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg" alt=""></div>
</div>

<!--<div id="loader2">
    <div id=""><img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Gif-Logo2.gif" alt=""></div>
</div>-->